import React, { FormEvent, useCallback } from 'react';
import { ErrorMessage, useField } from 'formik';
import { Form as SForm, Input, Label, Message, Checkbox, CheckboxProps } from 'semantic-ui-react';
import { isArray, isArrayLike } from 'lodash';
import { useFormikSchemaContext } from './FormikWithSchema';
import { BPCheckbox } from '@/components/bp/bpcheckbox';

interface Props {
    name: string;
    label?: string;
    [key: string]: any;
    onChange?: (event: React.SyntheticEvent<HTMLInputElement, Event>, data: CheckboxProps) => void;
}

const SemanticFormikCheckbox: React.FC<Props> = ({ name, label, onChange, ...props }) => {
    const [field, meta, helpers] = useField(name);
    const schema = useFormikSchemaContext();
    const isRequired = schema?.isFieldRequired(name);
    const label_ = label ?? schema?.schema?.fields?.[name]?.spec?.label;
    
    const showError = meta.touched && !!meta.error;
    const handleChange = useCallback(async (event: FormEvent<HTMLInputElement>, data: CheckboxProps) => {
        field.onChange(event);
        await helpers.setTouched(true);

        if (onChange) {
            onChange(event, data);
        }
        
    }, [name, onChange, field.onChange]);
    return (
        <SForm.Field error={showError} required={props.required ?? isRequired} name={name}>
            {/* {label && <label htmlFor={name}>{label}</label>} */}
            <BPCheckbox id={props.id ?? `${name}_${field.value}`} name={name} label={label_} checked={field.checked ?? field.value} {...props} onChange={handleChange}  />
            {showError && <Label basic color="red" pointing>{meta.error}</Label>}
        </SForm.Field>
    );
};

export default SemanticFormikCheckbox;